import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DocumentListWorkspace } from '@/components/DocumentListWorkspace';
import { useI18n } from '@/lib/i18n';
import { type InvoiceListSearch, InvoiceListSearchSchema } from '@/lib/invoice-list-search';

export const Route = createFileRoute('/customer-orders/')({
  validateSearch: (search) => InvoiceListSearchSchema.parse(search),
  component: CustomerOrdersPage,
});

function CustomerOrdersPage() {
  const { t } = useI18n();
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  return (
    <DocumentListWorkspace
      documentType="customer_order"
      search={search}
      copy={{
        sectionLabel: t('customerOrders.sectionLabel'),
        pageTitle: t('customerOrders.pageTitle'),
        pageDescription: t('customerOrders.pageDescription'),
        uploadButton: t('customerOrders.newOrder'),
        uploadButtonAria: t('customerOrders.newOrderAria'),
        loadingTitle: t('customerOrders.loadingTitle'),
        count: (count) => t('customerOrders.count', { count }),
        loadError: t('customerOrders.loadError'),
        errorTitle: t('customerOrders.errorTitle'),
        retry: t('invoiceList.retry'),
        filters: {
          searchLabel: t('customerOrdersTable.searchLabel'),
          searchPlaceholder: t('customerOrdersTable.searchPlaceholder'),
        },
        table: {
          columnNumber: t('customerOrdersTable.columnNumber'),
          columnCounterparty: t('customerOrdersTable.columnCustomer'),
          columnAmount: t('customerOrdersTable.columnAmount'),
          columnTradingMargin: t('customerOrdersTable.columnTradingMargin'),
          columnIssueDate: t('customerOrdersTable.columnIssueDate'),
          emptyTitle: t('customerOrdersTable.emptyTitle'),
          emptyDescription: t('customerOrdersTable.emptyDescription'),
          selectAllAria: t('customerOrdersTable.selectAllAria'),
          selectItemAria: (order) => t('customerOrdersTable.selectOrderAria', { order }),
          selectionCount: (count) => t('customerOrdersTable.selectionCount', { count }),
          bulkDeleteTitle: t('customerOrdersTable.bulkDeleteTitle'),
          bulkDeleteDescription: (count) =>
            t('customerOrdersTable.bulkDeleteDescription', { count }),
        },
      }}
      onSearchChange={(next) => {
        void navigate({
          search: (prev) => ({ ...(prev as InvoiceListSearch), ...next }),
          replace: false,
        });
      }}
      onOpenDetail={(id) => {
        void navigate({ to: '/invoices/$id', params: { id } });
      }}
    />
  );
}
